<template>
  <header class="main-header">
    <div class="container">
      <!-- Link zur Startseite mit dem Logo/Markennamen -->
      <div class="brand">
        <router-link to="/" class="brand-link">
          <img src="/logo.png" alt="Wetter-Wetter Logo" class="brand-logo" />
          <span class="brand-text">Wetter-Wetter</span>
        </router-link>
      </div>

      <!-- Hauptnavigationslinks -->
      <nav class="main-nav">
        <router-link to="/">Home</router-link>
        <router-link to="/chat">Chat</router-link>
        <router-link to="/online">Online</router-link>
        <router-link to="/podest">Ranking</router-link>
        <router-link to="/impressum">Impressum</router-link>
      </nav>

      <!-- Aktionen wie Login/Logout und Theme-Umschalter -->
      <div class="actions">
        <!-- Bedingte Anzeige basierend auf dem Login-Status -->
        <template v-if="ready && user">
          <!-- Zeigt Benutzerinformationen und Logout an, wenn der Benutzer eingeloggt ist -->
          <router-link to="/me"><span class="user-info">
            {{ user.email }} ({{ user.balance }} €)
          </span></router-link>
          <a href="#" @click.prevent="handleLogout" class="nav-link">Logout</a>
        </template>

        <!-- Zeigt Login- und Registrierungslinks an, wenn der Benutzer nicht eingeloggt ist -->
        <template v-else-if="ready">
          <router-link to="/login" class="nav-link">Login</router-link>
          <router-link to="/register" class="nav-link button">Registrieren</router-link>
        </template>

        <!-- Ladeanzeige, während der Auth-Status geprüft wird -->
        <template v-else><span class="user-info">Prüfe Login…</span></template>

        <button @click="toggleTheme" class="theme-toggle" :title="`Aktuelles Theme: ${theme}`">🌗</button>
      </div>
    </div>
  </header>
  <!-- Der <router-view> ist der Platzhalter, in den der Vue Router die zur aktuellen URL passende Komponente lädt. -->
  <router-view />
</template>

<style lang="scss" scoped>

.main-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: $card-background;
  border-bottom: 1px solid $border-color;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  padding: 0 2rem;
  box-sizing: border-box;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand a {
  font-size: 1.5rem;
  font-weight: bold;
  color: $text-color;
  text-decoration: none;
}

.brand-link {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem; /* Abstand zwischen Text und Logo */
  text-decoration: none;
  color: inherit;
}

.brand-text {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1;
}

.brand-logo {
  width: 36px;
  height: 36px;
  object-fit: contain;
  display: inline-block;
  vertical-align: middle;
  border-radius: 6px; /* optional */
}


.main-nav {
  flex-grow: 1;
  margin-left: 2rem;
}

.nav-link, .main-nav a {
  color: $text-color;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: rgba($primary-color, 0.1);
  }

  &.router-link-exact-active {
    color: $primary-color;
    font-weight: bold;
  }
}

.actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-info {
  color: $text-color;
  font-size: 0.9rem;
}

.theme-toggle {
  background: transparent;
  color: $text-color;
  border: none;
  border-radius: 6px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: rgba($primary-color, 0.1);
  }
}

</style>

<script setup>
// Importiert notwendige Funktionen und Composables aus Vue und anderen Modulen.
import { onMounted } from 'vue'
import { useAuth } from './composables/useAuth'
import { useTheme } from './composables/useTheme'
import { useRouter } from 'vue-router';
import { discordLogin } from './services/api';

const { user, ready, refreshAuth, logout } = useAuth()


const { theme, toggleTheme } = useTheme()

// Lifecycle-Hook: Prüft den Auth-Status beim ersten Laden der Komponente.
onMounted(() => void refreshAuth())

// Handler für den Logout-Klick.
const handleLogout = async () => await logout();

const router = useRouter();

// Lifecycle-Hook: Wird ausgeführt, wenn die Komponente eingehängt wird.
onMounted(() => {
  console.log('App gestartet');
  try {
    // Prüft, ob ein Discord-Autorisierungscode in der URL vorhanden ist.
    const params = new URLSearchParams(window.location.search);
    if (params.has('code')) {
      const code = params.get('code');
      console.log('Discord Code gefunden:', code);
      (async ()=>{
        // Sendet den Code an das Backend, um den Login abzuschließen.
        const result = await discordLogin(code, window.location.origin+window.location.pathname);

        console.log("Discord Login:", result);
        // Leitet nach erfolgreichem Login zur Startseite weiter.
        router.push("/");
      })();
    }
  } catch (e) {
      console.log(e);
  }
});
</script>
